<template>
  <div>
    <div style="text-align: center">
      <div v-if="!current.fecha_finalizacion" style="z-index: 1000 !important"
        class="floated-colors-btn second-floated-btn" data-toggle="modal" data-target="#modalAddConteoE">
        <i class="fas fa-check"></i>&nbsp;&nbsp;Agregar
      </div>
    </div>
    <h6>Conteos Individuales Agregados</h6>
    <br />
    <div class="invoice-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="text-center">Tipo Conteo</th>
            <th class="text-center">Número</th>
            <th class="text-center">Usuario</th>
            <th class="text-center">Fecha</th>
            <th class="text-center">Tienda</th>
            <th class="text-center">Status</th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="detalle in dataTabla" v-bind:key="detalle.id">
            <td class="text-center">{{ tipoConteoTexto(detalle.tipo) }}</td>
            <td class="text-center">{{ detalle.numero }}</td>
            <td class="text-center">
              {{ detalle.usuario.name }}
            </td>
            <td class="text-center">{{ detalle.fecha }}</td>
            <td class="text-center">
              {{ detalle.tienda_obj.nombre }}
            </td>
            <td class="text-center">{{ obtenerEstado(detalle.fecha_finalizacion) }}</td>
            <td class="text-center">
              <button :disabled="current.fecha_finalizacion" class="btn btn-sm btn-danger"
                @click="eliminar_conteo_de_agrupado(detalle)">
                <i class="fas fa-times"></i>
              </button>
              <button class="btn btn-sm btn-success" @click="abrirEnlace(detalle.id)">
                <i class="fas fa-share"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-------------------- END - Basic Table -------------------->
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddConteoE" role="dialog" tabindex="-1" data-backdrop="static"
      data-keyboard="false">
      <div class="modal-dialog modal-xl" role="document" >
        <div class="modal-content modal-Xl">
          <div class="modal-header">
            <h5 class="modal-title">Agregar conteo</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-4">
                <label>Fecha de Conteo</label>
                <input class="form-control form-control-sm" placeholder="Fecha Conteo" type="date"
                  v-model="filter.fecha" id="input_fecha" />
              </div>
              <div class="col-3">
                <label>Número</label>
                <input class="form-control form-control-sm" placeholder="Conteo #123" type="text"
                  v-model="filter.numero" id="input_conteo2" />
              </div>
              &nbsp
              <div class="col-3 column align-self-end" style="padding: 0;">
                <button @click="refreshConteoE()" class="btn btn-md btn-success" type="button" >
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn btn-md btn-dark" type="button" @click="undo()">
                  <i class="fas fa-undo "></i>
                </button>
              </div>
            </div>
            <hr />
            <div>
              <br />
              <div class="invoice-table">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-center">Tipo Conteo</th>
                      <th class="text-center">Número</th>
                      <th class="text-center">Usuario</th>
                      <th class="text-center">Fecha</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Tienda</th>
                      <th class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in dataTablaFilter" v-bind:key="detalle.id">
                      <td class="text-center">{{ tipoConteoTexto(detalle.tipo) }}</td>
                      <td class="text-center">{{ detalle.numero }}</td>
                      <td class="text-center">{{ detalle.usuario.name }}</td>
                      <td class="text-center">
                        {{ detalle.fecha_creacion | moment("DD/MM/YYYY hh:mm a") }}
                      </td>
                      <td class="text-center">{{ obtenerEstado(detalle.fecha_finalizacion) }}</td>
                      <td class="text-center">{{ detalle.tienda_obj.nombre }}</td>
                      <td class="d-flex justify-content-center align-items-center">
                        <br />
                        <button @click="agregarConteo(detalle)" class="btn btn-primary btn-success btn-md">
                          <i class="fas fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import Notifications from "@/notifications/notifications";

import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    UsuarioEnTablaComponent,
    ProductoSelectComponentV2,
  },
  props: {
    dataTabla: {
      type: Array,
      required: true,
    },
    current: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filter: {
        fecha: "",
      },
      dataTablaFilter: {},
      mostrarRefresh: false,
      currentPage: 1,
      posiciones: [],
      searchtext: "",
      filtro_estado: "",
      errors: "",
    };
  },
  computed: {},
  mounted() { },
  methods: {
    agregarConteo(det) {
      let self = this;
      DynamicService.postAction(
        "inv",
        "conteo-agrupado",
        self.current.id,
        "agregar_conteo_normal_a_conteo_agrupado",
        { id: det.id }
      )
        .then((response) => {
          Notifications.alert.success(
            "Agregar conteo al conteo agrupado",
            "Realizado con éxito."
          );
          self.$emit("refresh", event);
          $("#modalAddConteoE").modal("hide");
          this.undo();
        })
        .catch((error) => {
          Notifications.alert.error(
            "Agregar conteo al conteo agrupado",
            error.response.data.detail
          );
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },
    refreshConteoE() {
      if (this.filter.fecha) {
        this.fecha = moment(this.filter.fecha).format("DD/MM/YYYY");
      }
      DynamicService.fetch("inv", "conteo-inventario", {
        fecha: this.fecha,
        tienda: this.current.tienda,
        numero: this.filter.numero,
      }).then((response) => {
        this.dataTablaFilter = response.data.results;
      });
    },
    eliminar_conteo_de_agrupado(det) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar Conteo Asociado",
        "¿Esta seguro de eliminar el registro?",
        "Si, Eliminar",
        function () {
          DynamicService.postAction(
            "inv",
            "conteo-agrupado",
            self.current.id,
            "eliminar_conteo_de_agrupado",
            det
          )
            .then((response) => {
              Notifications.alert.success("¡Hecho!", "Se ha eliminado la línea.");
              self.$emit("refresh", event);
            })
            .catch((error) => {
              Notifications.alert.error(
                "Eliminar conteo de agrupado",
                error.response.data.detail
              );
            });
        }
      );
    },
    tipoConteoTexto(tipo) {
      switch (tipo) {
        case 'N':
          return 'Normal';
        case 'A':
          return 'Agrupado';
        case 'B':
          return 'ABC';
        case 'P':
          return 'Próximos a Vencer';
        case 'R':
          return 'Revisión 80/20'
        default:
          return 'Tipo desconocido';
      }
    },
    obtenerEstado(status) {
      return status ? 'Finalizado' : 'En Proceso';
    },
    abrirEnlace(id) {
      // Procedimiento para que al abrir el enlace, se pueda generar en una pantalla en blanco ;)
      const url = this.$router.resolve({ name: 'inventario-conteo-editar', params: { id } }).href;
      window.open(url, '_blank');
    },
  },
};
</script>
